module.exports = __webpack_public_path__ + "static/media/sample_mll_wagonsheet.1344819b.csv";